export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.302.2-32fbb7b",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
